import React, { useEffect } from 'react';
import AlertsNav from "../components/alertsnav";
import { withTheme } from 'styled-components';
import { injectIntl } from "react-intl";
import useAlerts from '../hooks/alerts';
import styled from 'styled-components';

const AlertsRouteWrapperDiv = styled.div`
  margin-top: -1px;
  background-color: ${({ theme }) => theme.background};
`;

const AlertDayComponentDiv = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.alerts.listSection.background};
  color: ${({ theme }) => theme.button.flat.subtitle.color};
`;

const AlertDayTitleDiv = styled.div`
  flex: 1;
  min-height: 24px;
  max-height: 24px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  margin: 0 0 0 15px;
  border-bottom: 1px solid ${({ theme }) => theme.alerts.listSection.borderColor};
  color: ${({theme}) => theme.subtitle.color};
`;

const AlertDiv = styled.div`
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.color};
  padding-left: 15px;
  position: relative;
  min-height: 72px;
  max-height: 72px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const AlertTitleDiv = styled.div`
  color: ${({ theme }) => theme.color};
  padding-top: 6px;
  min-height: 18px;
  max-height: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: bold;
  white-space: nowrap;
  padding-right: 100px;
  font-size: 16px;
  padding-bottom: 3px;
`;


const AlertBodyWrapperDiv = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.alerts.listSection.borderColor};
  color: ${({ theme }) => theme.button.flat.subtitle.color};
  padding-top: 2px;
  padding-right: 100px;
  font-weight: 300;
  padding-bottom: 7px;
  overflow: hidden;
  min-height: 45px;
  max-height: 45px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const AlertBodyDiv = styled.div`
  font-size: 14px;
  max-height: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  color: ${({ theme }) => theme.button.flat.subtitle.color};
`;

const AlertTimeDiv = styled.div`
  color: ${({ theme }) => theme.button.flat.subtitle.color};
  position: absolute;
  right: 16px;
  top: 13px;
  font-size: 10px;
  font-weight: 300;
`;

const AlertMarkerDiv = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
`;


const Alerts = withTheme(injectIntl(({ history, intl, theme }) => {
  const [{ alertHistory }, { getAlertsHistory, clearAlertsHistory }] = useAlerts();
  const alertsHistoryMap = new Map();
  const populateAlertsMap = () => {
    alertsHistoryMap.clear();
    getAlertsHistory().forEach(alert => {
      const alertDate = new Date(alert.timestamp);
      const isToday = !alertDate.toDateString().localeCompare((new Date()).toDateString());
      const alertDateMark = `${ isToday ? 'TODAY, ' : ''}${alertDate.toLocaleString('default', { month: 'short' }).toUpperCase()} ${alertDate.getDate()}`;
      const alertDateCollection = alertsHistoryMap.has(alertDateMark) ? alertsHistoryMap.get(alertDateMark) : [];

      alertDateCollection.push(alert);
      alertsHistoryMap.set(alertDateMark, alertDateCollection);
    });
  };

  const getAlertComponent = alert => {
    const {
        timestamp,
        alertBodyText,
        alertHeadingText,
        type,
        alertLevel,
    } = alert;
    const alertDate = new Date(timestamp);
    const titleText = alertBodyText ? alertHeadingText : (type || alertLevel);
    const bodyText = alertBodyText || alertHeadingText;
    const alertTime = alertDate.toLocaleString('en-US', { hour: 'numeric', hour12: true, minute: 'numeric' });
    const alertMarkerStyle = {
      backgroundColor: theme.alerts.listSection.markers[alertLevel].background,
    };

    return (
        <AlertDiv key={timestamp}>
          <AlertMarkerDiv style={{ ...alertMarkerStyle }}/>
          <AlertTitleDiv title={titleText}>
            { titleText }
          </AlertTitleDiv>
          <AlertBodyWrapperDiv title={bodyText}>
            <AlertBodyDiv>
              { bodyText }
            </AlertBodyDiv>
          </AlertBodyWrapperDiv>
          <AlertTimeDiv>{ alertTime }</AlertTimeDiv>
        </AlertDiv>
    );
  };

  const getAlertDayComponent = (key) => {
    const dayAlertCollection = alertsHistoryMap.get(key);

    return (
      <AlertDayComponentDiv key={key}>
        <AlertDayTitleDiv>{ key }</AlertDayTitleDiv>
        <div>
          { dayAlertCollection.map(getAlertComponent) }
        </div>
      </AlertDayComponentDiv>
    );
  };

  useEffect(() => {
    populateAlertsMap();
  }, [alertHistory.length]);

  populateAlertsMap();

  return (
    <AlertsRouteWrapperDiv className="settingsRoute">
      <AlertsNav cbBackClick={() => history.goBack()}
        cbClearAllClick={() => clearAlertsHistory()}>
        { [...alertsHistoryMap.keys()].map(getAlertDayComponent) }
      </AlertsNav>
    </AlertsRouteWrapperDiv>
  );
}));

export default Alerts;
